import { styled } from '@project44/manifest-ui-deprecated';

import { PANEL_WIDTH } from '../../utils/constants/PANEL_WIDTH';

export const Wrap = styled('div')(
  ({ expandedwidth }: { expandedwidth?: number }) => ({
    transition: 'width 0.2s ease',
    flexShrink: 0,
    width: 0,
    height: '100%',
    overflow: 'hidden',
    background: 'transparent',
    boxShadow:
      '0px 9px 12px rgba(0, 0, 0, 0.05), 0px 3px 16px rgba(0, 0, 0, 0.04), 0px 5px 6px rgba(0, 0, 0, 0.06)',
    '&.collapsible-active': {
      width: expandedwidth || PANEL_WIDTH,
    },
    '> div': {
      borderTopLeftRadius: '0',
      borderBottomLeftRadius: '0',
    },
  }),
);
